import React from 'react';

export function priceName(price){
	if (price >=1000) {
		return <div className='MainItemTag'>Dyr</div>
	} else if(price <= 300) {
		return <div className='MainItemTag'>Billig</div>
	} else if (price <= 500){
		return <div className='MainItemTag'>Normal</div>
	} else if (price <= 999) {
		return <div className='MainItemTag'>Næsten dyr</div>
	}
	else {
		return ''
	}

}

export function priceList(price){
	if (price >=1000) {
		return 'Dyr'
	} else if(price <= 300) {
		return 'Billig'
	} else if (price <= 500){
		return 'Normal'
	} else if (price <= 999) {
		return 'Næsten dyr'
	}
	else {
		return ''
	}

}


// WEBPACK FOOTER //
// ./src/components/elements/helper.js